import { Stack } from "@mui/material";

import ManageCompanyFilter from "./ManageCompanyFilter";
import TaxExemptFilter from "./TaxExemptFilter";
import TermFilterInput from "./TermFilterInput";

export default function FilterHeader() {
	return (
		<Stack direction='row' alignItems={"center"} sx={{ px: 3, pb: 2 }} spacing={2}>
			<TermFilterInput />
			<ManageCompanyFilter />
			<TaxExemptFilter />
		</Stack>
	);
}
